import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

export function getPasswordStrength(password) {
  const checks = {
    minLength: (password || '').length >= 8,
    letter: /[A-Za-zÀ-ÿ]/.test(password || ''),
    number: /\d/.test(password || ''),
    special: /[^A-Za-zÀ-ÿ0-9]/.test(password || ''),
  };
  const score = Object.values(checks).filter(Boolean).length;
  return { checks, score, valid: score === 4 };
}

export function PasswordStrength({ password }) {
  const { checks, score } = getPasswordStrength(password);
  const percent = score * 25;
  const label = score <= 1 ? 'Fraca' : score <= 3 ? 'Média' : 'Forte';
  const color = score <= 1 ? '#ef4444' : score <= 3 ? '#f59e0b' : '#059669';
  const items = [
    ['minLength', 'Mínimo de 8 caracteres'],
    ['letter', '1 letra'],
    ['number', '1 número'],
    ['special', '1 caractere especial'],
  ];
  return (
    <div className="space-y-2" data-testid="password-strength-meter">
      <div className="flex items-center justify-between text-xs font-medium text-slate-600">
        <span>Força da senha</span>
        <span data-testid="password-strength-label">{label}</span>
      </div>
      <div className="h-2 rounded-full bg-slate-200 overflow-hidden" data-testid="password-strength-progress">
        <div className="h-full rounded-full transition-all duration-300" style={{ width: `${percent}%`, backgroundColor: color }} aria-hidden="true" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 pt-1">
        {items.map(([key, text]) => (
          <div key={key} className={`flex items-center gap-1.5 text-xs ${checks[key] ? 'text-emerald-700' : 'text-slate-500'}`} data-testid={`password-rule-${key}`}>
            {checks[key] ? <CheckCircle2 className="w-3.5 h-3.5" /> : <XCircle className="w-3.5 h-3.5" />}
            {text}
          </div>
        ))}
      </div>
    </div>
  );
}